<template>
  <div class="home">
    <d-header></d-header>

    <data-report></data-report>
    <d-footer></d-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import DHeader from "../components/Header";
import DFooter from "../components/Footer";
import DataReport from "../components/table/Datareport";

export default {
  name: 'home',
  components: {
    DataReport,
    DHeader,
    DFooter
  }
}
</script>
